import { render, staticRenderFns } from "./TgHeaderLogo.vue?vue&type=template&id=6760c57e"
import script from "./TgHeaderLogo.vue?vue&type=script&lang=js"
export * from "./TgHeaderLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports